export default "__VITE_ASSET__hJNQb4aZ__"